import 'react';
import { PropTypes } from 'prop-types';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { jsxs, jsx } from 'react/jsx-runtime';

function ChipOverlay(_ref) {
  var chipLabel = _ref.chipLabel,
    _ref$chipBackgroundCo = _ref.chipBackgroundColor,
    chipBackgroundColor = _ref$chipBackgroundCo === void 0 ? 'primary.main' : _ref$chipBackgroundCo,
    children = _ref.children;
  return /*#__PURE__*/jsxs(Paper, {
    elevation: 0,
    style: {
      position: 'relative',
      width: '100%',
      height: '100%'
    },
    children: [children, chipLabel && /*#__PURE__*/jsx(Chip, {
      label: /*#__PURE__*/jsx(Typography, {
        children: /*#__PURE__*/jsx("strong", {
          children: chipLabel
        })
      }),
      sx: {
        position: 'absolute',
        top: 10,
        left: 10,
        zIndex: 1,
        backgroundColor: chipBackgroundColor,
        color: 'primary.contrastText'
      }
    })]
  });
}
ChipOverlay.propTypes = {
  /**
   * This is used to set the text on chip.
   */
  chipLabel: PropTypes.string.isRequired,
  /**
   * This is used to set background color for the chip. Make sure to use MUI theme colors that has both light and dark mode variations by default. If not, make sure to define those colors in eve-themes-react project and use it.
   */
  chipBackgroundColor: PropTypes.string,
  /**
   * Consumer can pass in component that they need chip overlay on. Chip will be placed on top of this element positioned on top left corner.
   */
  children: PropTypes.element.isRequired
};

export { ChipOverlay as default };
//# sourceMappingURL=index.esm.js.map
